import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appointments: [],
};

export const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    updateAppointments: (state, action) => {
      state.appointments = action.payload.reverse();
    },
  },
});

export const { updateAppointments } = appointmentsSlice.actions;
export default appointmentsSlice.reducer;
